import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Who is Precision Running coaching for?",
    a: "My coaching is suited to runners who want to maximize their potential rather than just follow a generic or AI generated plan.",
  },
  {
    q: "Do I need to be a fast or experienced runner?",
    a: "Not at all. My coaching can be tailored to any level of runner.",
  },
  {
    q: "What running events do you coach?",
    a: "I specialize in coaching for the 5K up to the Half-Marathon distance.",
  },
  {
    q: "How is the program delivered?",
    a: "All programming is delivered via the FinalSurge training platform. You will get a simple calendar view of your program with workout notes, explanations, and feedback.",
  },
  {
    q: "What if I miss a session or get sick?",
    a: "Life happens. Message me and we adjust the week. Plans are dynamic — they flex around your body, work and family.",
  },
  {
    q: "Do you work with runners internationally?",
    a: "Yes. Coaching is fully online — I am currently working with athletes in Australia and Europe.",
  },
  {
    q: "Is there a minimum commitment?",
    a: "Coaching is billed monthly and I recommend a minimum of 12 weeks leading up to a goal race. However, I can work with shorter time-frames if required.",
  },
  {
    q: "How much does it cost?",
    a: "Online coaching starts at $55/month USD, premium online coaching is $70/month USD, and premium coaching with a weekly phone call is $120/month USD. All payments are made on the Final Surge platform which uses USD currency.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-24 lg:py-32 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-4 mb-6">
              <span className="font-mono text-brand-red text-xs tracking-widest">06</span>
              <span className="label-eyebrow">FAQ</span>
            </div>
            <h2 className="font-display uppercase text-white text-5xl lg:text-6xl leading-[0.9] tracking-tight">
              Questions, <span className="text-brand-red">answered.</span>
            </h2>
            <p className="mt-6 text-white/60 leading-relaxed max-w-md">
              Any questions? Drop a note in the contact form. We can also organise a
              quick phone chat.
            </p>
          </div>

          <div className="lg:col-span-8">
            <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-b border-white/10 first:border-t"
                >
                  <AccordionTrigger className="text-left py-6 text-white hover:text-brand-red hover:no-underline group">
                    <span className="flex items-start gap-4">
                      <span className="font-mono text-brand-red text-xs tracking-widest mt-1">
                        Q/{String(i + 1).padStart(2, "0")}
                      </span>
                      <span className="font-display uppercase text-xl lg:text-2xl tracking-wide leading-snug">
                        {f.q}
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="text-white/70 pb-6 pl-[3.5rem] pr-2 text-base leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
}
